import React from "react";
import BreadcrumpTemp from "../Template/BreadcrumpTemp";

import spyderImg from "../../img/Service-Product/50kg.png";

// Import PDFs (Update the paths according to your project)
import brochure from "../../assets/brochures/Spyder.pdf";
import techSpecs from "../../assets/tech-specs/Spyder Tech Specs.pdf";

export default function SpyderTheWeightLifter() {
  const breadProp = {
    title: "Spyder The Weight Lifter",
    text: "Heavy Payload Drone",
    arr: ["Home", "Products", "Spyder The Weight Lifter"],
  };

  return (
    <div>
      <BreadcrumpTemp bprops={breadProp} />

      <div
        style={{
          maxWidth: "1200px",
          margin: "40px auto",
          padding: "0 20px",
        }}
      >
        {/* <h1
          style={{
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "700",
          }}
        >
          Spyder The Weight Lifter
        </h1> */}

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "40px",
          }}
        >
          {/* Product Image */}
          <div style={{ flex: "1", minWidth: "420px", textAlign: "center" }}>
            <img
              src={spyderImg}
              alt="Spyder The Weight Lifter"
              style={{
                width: "100%",
                maxWidth: "450px",
                height: "auto",
                borderRadius: "12px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
              }}
            />
          </div>

          {/* Product Description */}
          <div style={{ flex: "1", minWidth: "320px" }}>
            <h2>Heavy Payload Drone</h2>


            <p style={{ lineHeight: "1.8", textAlign: "justify" }}>
              <strong>Spyder The Weight Lifter</strong> is a high-performance
              heavy-lift drone engineered for industrial, logistics, defence,
              and emergency response operations. It is capable of carrying
              payloads up to <strong>50 kg</strong> while maintaining excellent
              flight stability and efficiency.
            </p>

            <p style={{ lineHeight: "1.8", textAlign: "justify" }}>
              Equipped with a smart hoist system / Winch mechanism, high-efficiency propulsion,
              and long-endurance batteries, Spyder delivers reliable
              performance for demanding missions where precision and lifting
              capability are essential.
            </p>

            {/* Download Buttons */}
            <div
              style={{
                display: "flex",
                gap: "20px",
                marginTop: "30px",
                flexWrap: "wrap",
              }}
            >
              <a
                href={brochure}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#007bff",
                  color: "#fff",
                  padding: "12px 24px",
                  textDecoration: "none",
                  borderRadius: "6px",
                  fontWeight: "600",
                }}
              >
                View Brochure
              </a>

              <a
                href={techSpecs}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#28a745",
                  color: "#fff",
                  padding: "12px 24px",
                  textDecoration: "none",
                  borderRadius: "6px",
                  fontWeight: "600",
                }}
              >
                View Tech Specs
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}